import { render, staticRenderFns } from "./BankTransactionStatistics.vue?vue&type=template&id=2855b67c&scoped=true"
import script from "./BankTransactionStatistics.vue?vue&type=script&lang=js"
export * from "./BankTransactionStatistics.vue?vue&type=script&lang=js"
import style0 from "./BankTransactionStatistics.vue?vue&type=style&index=0&id=2855b67c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2855b67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2855b67c')) {
      api.createRecord('2855b67c', component.options)
    } else {
      api.reload('2855b67c', component.options)
    }
    module.hot.accept("./BankTransactionStatistics.vue?vue&type=template&id=2855b67c&scoped=true", function () {
      api.rerender('2855b67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/BankTransactionStatistics.vue"
export default component.exports